import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
   {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "about" */ './components/Login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      redirect: {
          name: 'Excel Formatted Orders',
      },
    },
    {
      path: '/companies',
      name: 'Companies',
      component: () => import(/* webpackChunkName: "about" */ './components/Companies.vue'),
      meta: { requiresAuth: true },
    }, {
      path: '/orders',
      name: 'Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/Orders.vue'),
      meta: { requiresAuth: true },
    },
      {
          path: '/completed-orders',
          name: 'Completed Orders',
          component: () => import(/* webpackChunkName: "about" */ './components/CompletedOrders.vue'),
          meta: { requiresAuth: true },
      },
      {
          path: '/cancel-orders',
          name: 'Cancel Orders',
          component: () => import(/* webpackChunkName: "about" */ './components/CancelOrders.vue'),
          meta: { requiresAuth: true },
      },
      {
          path: '/rejected-orders',
          name: 'Rejected Orders',
          component: () => import(/* webpackChunkName: "about" */ './components/RejectedOrders.vue'),
          meta: { requiresAuth: true },
      },
      {
          path: '/city-wise-orders',
          name: 'City Wise Orders',
          component: () => import(/* webpackChunkName: "about" */ './components/CityWiseOrdersSheet.vue'),
          meta: { requiresAuth: true },
      },
      {
          path: '/excel-formatted-orders',
          name: 'Excel Formatted Orders',
          component: () => import(/* webpackChunkName: "about" */ './components/ExcelFormattedOrders/ExcelFormattedOrders.vue'),
          meta: { requiresAuth: true },
      },
    {
      path: '/manage',
      name: 'Manage',
      component: () => import(/* webpackChunkName: "about" */ './components/ManageKanban.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/users',
      name: 'Users',
      component: () => import(/* webpackChunkName: "about" */ './components/Users.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/contractors',
      name: 'Contractors',
      component: () => import(/* webpackChunkName: "about" */ './components/Contractors.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import(/* webpackChunkName: "about" */ './components/Settings/Settings.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/tempo-orders',
      name: 'Tempo Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/VehicleManagement/TempoOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/truck-orders',
      name: 'Truck Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/VehicleManagement/TruckOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-truck-orders',
      name: 'Excel Truck Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTruckOrders/ExcelTruckOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-truck-orders/:id',
      name: 'Truck Order Detail',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTruckOrders/TruckOrderDetail.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/completed-truck-orders',
      name: 'Completed Truck Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTruckOrders/CompletedTruckOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/cancel-truck-orders',
      name: 'Cancel Truck Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTruckOrders/CancelTruckOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-tempo-orders',
      name: 'Excel Tempo Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTempoOrders/ExcelTempoOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-tempo-orders/:id',
      name: 'Tempo Order Detail',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTempoOrders/TempoOrderDetail.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/completed-tempo-orders',
      name: 'Completed Tempo Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTempoOrders/CompletedTempoOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/cancel-tempo-orders',
      name: 'Cancel Tempo Orders',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTempoOrders/CancelTempoOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-clients',
      name: 'Excel Clients',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelClients/ExcelClients.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-clients/:id',
      name: 'Client Detail',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelClients/ClientDetail.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-transporters',
      name: 'Excel Transporters',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTransporters/ExcelTransporters.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-transporters/:id',
      name: 'Transporter Detail',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelTransporters/TransporterDetail.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-contractors',
      name: 'Excel Contractors',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelContractors/ExcelContractors.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/excel-contractors/:id',
      name: 'Contractor Detail',
      component: () => import(/* webpackChunkName: "about" */ './components/ExcelContractors/ContractorDetail.vue'),
      meta: { requiresAuth: true },
    },
  {
      path: '/todo',
      name: 'To Do',
      component: () => import(/* webpackChunkName: "about" */ './components/ToDoList.vue'),
      meta: { requiresAuth: true },
  },
    {
      path: '/gallery',
      name: 'Gallery',
      component: () => import(/* webpackChunkName: "about" */ './components/Gallery.vue'),
      meta: { requiresAuth: true },
  },
    {
      path: '/client-request',
      name: 'Client Registration',
      component: () => import(/* webpackChunkName: "about" */ './components/ClientRegistration/ClientRegistration.vue'),
      meta: { requiresAuth: true },
  },
    {
      path: '/lr',
      name: 'LR',
      component: () => import(/* webpackChunkName: "about" */ './components/LR/ExcelLR'),
      meta: { requiresAuth: true },
    },
    {
      path: '/create-client-invoices',
      name: 'Create Client Invoices',
      component: () => import(/* webpackChunkName: "about" */ './components/Client Billing/CreateClientInvoice/CreateInvoiceWrapper'),
      meta: { requiresAuth: true },
    },
    {
      path: '/authorize-client-invoices',
      name: 'Authorize Client Invoices',
      component: () => import(/* webpackChunkName: "about" */ './components/Client Billing/AuthorizeClientInvoices'),
      meta: { requiresAuth: true },
    },
    {
      path: '/client-invoices',
      name: 'Client Invoices',
      component: () => import(/* webpackChunkName: "about" */ './components/Client Billing/ClientInvoices'),
      meta: { requiresAuth: true },
    },
    {
      path: '/canceled-client-invoices',
      name: 'Canceled Client Invoices',
      component: () => import(/* webpackChunkName: "about" */ './components/Client Billing/CanceledClientInvoices'),
      meta: { requiresAuth: true },
    },
  ]
})

export default router

function checkPathAccessible(routepath){
    // let isAccessible = false
    let modifiedPath = routepath.match(/\/[^\/]+/i)[0]                  //   Replace '/excel-orders/2' with '/excel-orders'
    // for(var i = 0; i < store.state.userObj.menu.length; i++) {
    //     if(store.state.userObj.menu[i].url === modifiedPath){
    //         isAccessible = true
            // break
        // }
    // }
     return store.state.accessibleUrls.indexOf(modifiedPath) !== -1
  }

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem('token') || !store.state.userObj){
            router.replace({ path: '/login'})
        }else if(checkPathAccessible(to.path)){
            next()
        }else{
          console.log('path inaccessible')
          router.replace({ path: (store.state.accessibleUrls.length)?(store.state.accessibleUrls[0]):'/login'})
        }
    } else {
        if(localStorage.getItem('token') && store.state.userObj && store.state.accessibleUrls.length){
            router.replace({ path: store.state.accessibleUrls[0]})
        } else {
            next()
        }
    }
})
